import { PredictionRequest } from '@staycool/contests-types/prediction';
import { getServiceUrl, httpGet, httpPost, httpPut } from '../services/api';
import { logger } from '../services/logger';
import { FoContest, ShortFoContest } from '@staycool/contests-types/contest';
import { EntryWithPredictions } from '@staycool/contests-types/entry';

const getUrl = (url) => getServiceUrl('contests', url);

export async function getContestsList() {
    const path = getUrl('contest/fo/list');
    return httpGet<{
        rows: ShortFoContest[];
        total: number;
    }>(path, { status: 'ACTIVE,FINISHED' });
}

export async function getContest(id: string) {
    const url = getUrl(`contest/fo/${id}`);
    try {
        return httpGet<FoContest>(url);
    } catch (error) {
        logger.error('ContestsMicroservice', 'getContest', error);
    }
}

export async function sendContestPrediction({ body, isResubmit }: { body: PredictionRequest; isResubmit: boolean }) {
    const url = getUrl(`fo/prediction`);

    try {
        if (isResubmit) {
            return httpPut<void>(url, body);
        } else {
            return httpPost<EntryWithPredictions[]>(url, body);
        }
    } catch (error) {
        logger.error('ContestsMicroservice', 'sendContestPrediction', error);
    }
}
